module.exports = require("querystring");;